module.exports = __webpack_public_path__ + "b-lite-2-after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/novinky/b-lite-2-after.jpg
// module id = 1854
// module chunks = 0